if ( module.hot ) {
	require( 'preact/devtools' );
}

import habitat from 'preact-habitat';

import Widget from './components/banner';

let _habitat = habitat( Widget );

_habitat.render( {
	selector     : '[data-widget-id="yleh-link-banner"]',
	defaultProps : {
		title               : 'Your Local Election Headquarters',
		linkTextColor       : 'rgba( 255, 255, 255, 0.85 )',
		linkBackgroundColor : 'rgba( 56, 63, 232, 0.85 )',
	},
	clean        : true,
} );



// WEBPACK FOOTER //
// ./index.js